// components/PrivateRoute.jsx
import { Navigate, Outlet } from "react-router-dom";

export default function PrivateRoute() {
  const isAuthenticated = localStorage.getItem("isLoggedIn") === "true"; // or use context/token
  return isAuthenticated ? <Outlet /> : <Navigate to="/verify-email" replace />;
}
